// src/types/User.ts
import { SubscriptionPlan } from "../../types/subsriptionPlans/subscriptionPlans";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const SubscriptionPlanService = {
  async getPlans(): Promise<SubscriptionPlan> {
    const res = await httpClient.get<SubscriptionPlan>(
      `${apiRoutePrefix}/getPlans`
    );
    return res.data;
  },
  // Add more auth-related calls as needed
};
